module.exports = __webpack_public_path__ + "img/asmnticon.822bf830.svg";